import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/horarios";

export const Route = createFileRoute("/_authenticated/horarios")({
  head: () => ({
    meta: [
      { title: "Horários de funcionamento — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Cadastro dos horários de abertura e fechamento de cada dia da sorveteria, com aviso dos dias ainda não definidos.",
      },
      { property: "og:title", content: "Horários de funcionamento — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Cadastro dos horários de abertura e fechamento de cada dia da sorveteria, com aviso dos dias ainda não definidos.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
